// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cdc050b2","488":"90eb9903","977":"76f120e4"}[chunkId] + ".chunk.js";
};